import React from 'react'

export function slctSelectInputValue(refInput: React.RefObject<HTMLInputElement | null>) {
	if (refInput.current && window.document.activeElement === refInput.current) {
		refInput.current?.select()
	}
}